import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Responsive, Accordion } from 'semantic-ui-react';
import autobind from 'react-autobind';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormList from './FormList';
import { tracking } from '../../utils/tracking';

class OptionsEnroll extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeIndex: '',
      formId: '',
      forms: [],
    };
    autobind(this);
  }

  componentDidUpdate () {
    tracking(this.trackroot); // needed for initial load
  }

  selectOption (formId) {
    let formName = '';
    switch (formId) {
      case 0:
        formName = 'PATIENT';
        break;
      case 1:
        formName = 'STAFF';
        break;
      case 2:
        formName = 'PHARMACIST';
        break;
      default:
        formName = '';
    }
    const source = _.find(this.props.formList, { formId: formName || formId });
    this.setState({ formId: source.formId, forms: source.forms });
    this.props.setOption(source.formId);
  }

  handleClickAccordion = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.selectOption(index);
    this.setState({ activeIndex: newIndex });
  }

  render () {
    const { formList } = this.props;
    const optionButtons = formList.map((form, key) => {
      return (
        <Button
          key={ key }
          className={ `${this.state.formId === form.formId ? 'selected' : ''} track ${form.tracking}` }
          onClick={ () => this.selectOption(form.formId)
          }
        >
          { form.formTitle }
        </Button>
      );
    });

    // mobile
    const accordionItems = formList.map((form, key) => {
      return (
        <div key={ key }>
          <Accordion.Title
            className={ this.state.activeIndex === key ? 'ui button selected' : 'ui button' }
            active={ this.state.activeIndex === key }
            index={ key }
            onClick={ this.handleClickAccordion }
          >
            {form.formTitle}
          </Accordion.Title>
          <Accordion.Content active={ this.state.activeIndex === key }>
            { this.state.formId && <FormList forms={ form.forms } /> }
          </Accordion.Content>
        </div>
      );
    });
    return (
      <div className="enroll-options" ref={ section => { this.trackroot = section; } }>
        <p>Please select the option that best describes you:</p>
        <Responsive minWidth={ 768 } className="desktop" >
          <div className="options">
            { optionButtons }
          </div>
          { this.state.formId && <FormList forms={ this.state.forms } /> }
        </Responsive>
        <Responsive maxWidth={ 767 } className="mobile">
          <Accordion className="options">
            { accordionItems }
          </Accordion>
        </Responsive>
      </div>
    );
  }
}

OptionsEnroll.propTypes = {
  setOption: PropTypes.func.isRequired,
  formList: PropTypes.array.isRequired,
};

export default withRouter(OptionsEnroll);
